const LOGO_HEIGHTS = {
  "text-sm": "h-5",
  "text-base": "h-6",
  "text-lg": "h-6",
  "text-xl": "h-7",
  "text-2xl": "h-8",
  "text-3xl": "h-10",
  "text-4xl": "h-12",
  "text-5xl": "h-14",
};

export function Logo({ className = "", size = "text-2xl" }) {
  const h = LOGO_HEIGHTS[size] || (size.includes("5xl") ? "h-14" : size.includes("4xl") ? "h-12" : "h-8");
  return (
    <span className={`inline-flex items-center gap-3 align-middle ${className}`} data-testid="app-logo">
      <img src="/aib-logo.png" alt="aiBLACK" className={`inline-block w-auto ${h}`} />
      <span className={`font-display font-black tracking-tighter ${size}`}>
        <span className="logo-ai">ai</span><span className="logo-black">BLACK</span>
      </span>
    </span>
  );
}

// Inline brand mark: white "ai" + orange "BLACK". Flows within body text.
export function Brand({ className = "" }) {
  return (
    <span className={className}>
      <span className="logo-ai">ai</span><span className="logo-black">BLACK</span>
    </span>
  );
}

// Renders a string and brands every "aiBLACK" occurrence inside it.
export function BrandText({ children }) {
  const parts = String(children).split(/(aiBLACK)/g);
  return parts.map((p, i) => (p === "aiBLACK" ? <Brand key={i} /> : <span key={i}>{p}</span>));
}
